import { useMutation } from '@tanstack/react-query';
import Swal from 'sweetalert2';
import { searchSocialAction } from './searchActions';
import { searchMetrics } from './searchMetrics';

export default function SearchDetailActions({ categoryId, item, onFeedback, refresh, variant }) {
  const mutation = useMutation({ mutationFn: searchSocialAction, onSuccess: refresh });
  const act = async (action) => {
    try { await mutation.mutateAsync({ categoryId, id: item.id, action }); }
    catch (error) { Swal.fire({ icon: 'error', title: 'Action unavailable', text: error.message }); }
  };
  const metrics = searchMetrics(item);
  const stats = [
    { key: 'bookmark', icon: Number(item.bookmark_status) === 1 ? 'bi-bookmark-fill' : 'bi-bookmark', label: 'Bookmark' },
    { key: 'like', icon: Number(item.like_status) === 1 ? 'bi-heart-fill' : 'bi-heart', label: 'Like', count: metrics.likes },
    { key: 'view', icon: 'bi-eye', label: 'View', count: metrics.views },
    { key: 'report', icon: 'bi-exclamation-circle', label: 'Report', count: metrics.reports },
    { key: 'notes', icon: 'bi-journal-text', label: 'Notes', count: metrics.notes },
  ];
  return <div className={`footer-nav-fixed ${variant}`}><div className="qbank-stats">{stats.map((stat) => <button type="button" key={stat.key} className="qbank-stat" disabled={mutation.isPending} onClick={() => ['like', 'bookmark'].includes(stat.key) ? act(stat.key) : onFeedback(stat.key)}><i className={`bi ${stat.icon}`} /><span>{stat.label}</span>{stat.count !== undefined && <strong>{stat.count}</strong>}</button>)}</div></div>;
}
